"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActions = exports.HistoryParentEntities = void 0;
var HistoryParentEntities;
(function (HistoryParentEntities) {
    HistoryParentEntities["PAYMENT"] = "Payment";
    HistoryParentEntities["RECURRING_PAYMENT"] = "RecurringPayment";
    HistoryParentEntities["ORDER"] = "Order";
    HistoryParentEntities["PRODUCT"] = "Product";
    HistoryParentEntities["SUPPLIER"] = "Supplier";
    HistoryParentEntities["USER"] = "User";
    HistoryParentEntities["SELLER"] = "Seller";
    HistoryParentEntities["ROLE"] = "Role";
    HistoryParentEntities["CUSTOMER"] = "Customer";
    HistoryParentEntities["BULK_PAYMENT"] = "BulkPayment";
    HistoryParentEntities["BRAND"] = "Brand";
    HistoryParentEntities["CATEGORY"] = "Category";
    HistoryParentEntities["BANK_ACCOUNT"] = "BankAccount";
    HistoryParentEntities["API_KEY"] = "ApiKey";
    HistoryParentEntities["PICKUP_POINT"] = "PickupPoint";
    HistoryParentEntities["OFFICER"] = "Officer";
    HistoryParentEntities["TEAM_MEMBER"] = "TeamMember";
    HistoryParentEntities["INTEGRATION"] = "Integration";
    HistoryParentEntities["COMPANY"] = "Company";
    HistoryParentEntities["INVOICE"] = "Invoice";
    HistoryParentEntities["REMINDER"] = "Reminder";
    HistoryParentEntities["LOCATION"] = "Location";
    HistoryParentEntities["COMMERCIAL_INVOICE"] = "CommercialInvoice";
    HistoryParentEntities["EXTERNAL_APP"] = "ExternalApp";
})(HistoryParentEntities = exports.HistoryParentEntities || (exports.HistoryParentEntities = {}));
var HistoryActions;
(function (HistoryActions) {
    // For payments
    HistoryActions["PAYMENT_CREATE"] = "PAYMENT_CREATE";
    HistoryActions["PAYMENT_UPDATE"] = "PAYMENT_UPDATE";
    HistoryActions["PAYMENT_DELETE"] = "PAYMENT_DELETE";
    HistoryActions["PAYMENT_CANCEL"] = "PAYMENT_CANCEL";
    HistoryActions["PAYMENT_PROCESS"] = "PAYMENT_PROCESS";
    HistoryActions["PAYMENT_CREATE_AND_PROCESS"] = "PAYMENT_CREATE_AND_PROCESS";
    HistoryActions["PAYMENT_ATTACH_FILE"] = "PAYMENT_ATTACH_FILE";
    HistoryActions["PAYMENT_DETACH_FILE"] = "PAYMENT_DETACH_FILE";
    HistoryActions["PAYMENT_ADD_NOTE"] = "PAYMENT_ADD_NOTE";
    HistoryActions["PAYMENT_EDIT_NOTE"] = "PAYMENT_EDIT_NOTE";
    HistoryActions["PAYMENT_DELETE_NOTE"] = "PAYMENT_DELETE_NOTE";
    HistoryActions["PAYMENT_UPDATE_STATUS"] = "PAYMENT_UPDATE_STATUS";
    HistoryActions["PAYMENT_ARCHIVE"] = "PAYMENT_ARCHIVE";
    HistoryActions["PAYMENT_REFUND"] = "PAYMENT_REFUND";
    // For recurring payments
    HistoryActions["RECURRING_PAYMENT_CREATE"] = "RECURRING_PAYMENT_CREATE";
    HistoryActions["RECURRING_PAYMENT_UPDATE"] = "RECURRING_PAYMENT_UPDATE";
    HistoryActions["RECURRING_PAYMENT_CANCEL"] = "RECURRING_PAYMENT_CANCEL";
    HistoryActions["RECURRING_PAYMENT_RESTART"] = "RECURRING_PAYMENT_RESTART";
    HistoryActions["RECURRING_PAYMENT_CREATE_AND_PROCESS"] = "RECURRING_PAYMENT_CREATE_AND_PROCESS";
    HistoryActions["RECURRING_PAYMENT_PROCESS"] = "RECURRING_PAYMENT_PROCESS";
    HistoryActions["RECURRING_PAYMENT_ARCHIVE"] = "RECURRING_PAYMENT_ARCHIVE";
    HistoryActions["RECURRING_PAYMENT_ADD_NOTE"] = "RECURRING_PAYMENT_ADD_NOTE";
    HistoryActions["RECURRING_PAYMENT_EDIT_NOTE"] = "RECURRING_PAYMENT_EDIT_NOTE";
    HistoryActions["RECURRING_PAYMENT_DELETE_NOTE"] = "RECURRING_PAYMENT_DELETE_NOTE";
    HistoryActions["RECURRING_PAYMENT_UPDATE_STATUS"] = "RECURRING_PAYMENT_UPDATE_STATUS";
    HistoryActions["RECURRING_PAYMENT_ATTACH_FILE"] = "RECURRING_PAYMENT_ATTACH_FILE";
    HistoryActions["RECURRING_PAYMENT_DETACH_FILE"] = "RECURRING_PAYMENT_DETACH_FILE";
    // For orders
    HistoryActions["ORDER_CREATE"] = "ORDER_CREATE";
    HistoryActions["ORDER_UPDATE_STATUS"] = "ORDER_UPDATE_STATUS";
    HistoryActions["ORDER_MODIFY_ITEMS"] = "ORDER_MODIFY_ITEMS";
    HistoryActions["ORDER_UPDATE_DELIVERY_STATUS"] = "ORDER_UPDATE_DELIVERY_STATUS";
    HistoryActions["ORDER_UPDATE_CUSTOMER"] = "ORDER_UPDATE_CUSTOMER";
    HistoryActions["ORDER_UPDATE_PAYMENT_METHOD"] = "ORDER_UPDATE_PAYMENT_METHOD";
    HistoryActions["ORDER_UPDATE_DELIVERY_TYPE"] = "ORDER_UPDATE_DELIVERY_TYPE";
    HistoryActions["ORDER_DELETE"] = "ORDER_DELETE";
    HistoryActions["ORDER_PROCESS"] = "ORDER_PROCESS";
    HistoryActions["ORDER_CREATE_AND_PROCESS"] = "ORDER_CREATE_AND_PROCESS";
    HistoryActions["ORDER_ATTACH_NOTE"] = "ORDER_ATTACH_NOTE";
    HistoryActions["ORDER_EDIT_NOTE"] = "ORDER_EDIT_NOTE";
    HistoryActions["ORDER_DELETE_NOTE"] = "ORDER_DELETE_NOTE";
    HistoryActions["ORDER_CANCEL"] = "ORDER_CANCEL";
    HistoryActions["ORDER_REFUND"] = "ORDER_REFUND";
    HistoryActions["ORDER_SEND_RECEIPT"] = "ORDER_SEND_RECEIPT";
    HistoryActions["ORDER_ARCHIVE"] = "ORDER_ARCHIVE";
    HistoryActions["ORDER_UPDATE_COMMENT"] = "ORDER_UPDATE_COMMENT";
    // For customers
    HistoryActions["CUSTOMER_CREATE"] = "CUSTOMER_CREATE";
    HistoryActions["CUSTOMER_UPDATE"] = "CUSTOMER_UPDATE";
    HistoryActions["CUSTOMER_ADD_ADDRESS"] = "CUSTOMER_ADD_ADDRESS";
    HistoryActions["CUSTOMER_UPDATE_ADDRESS"] = "CUSTOMER_UPDATE_ADDRESS";
    HistoryActions["CUSTOMER_REMOVE_ADDRESS"] = "CUSTOMER_REMOVE_ADDRESS";
    HistoryActions["CUSTOMER_CHANGE_DEFAULT_ADDRESS"] = "CUSTOMER_CHANGE_DEFAULT_ADDRESS";
    HistoryActions["CUSTOMER_DELETE"] = "CUSTOMER_DELETE";
    HistoryActions["CUSTOMER_ARCHIVE"] = "CUSTOMER_ARCHIVE";
    HistoryActions["CUSTOMER_ADD_BANK_ACCOUNT"] = "CUSTOMER_ADD_BANK_ACCOUNT";
    HistoryActions["CUSTOMER_UPDATE_BANK_ACCOUNT"] = "CUSTOMER_UPDATE_BANK_ACCOUNT";
    HistoryActions["CUSTOMER_DELETE_BANK_ACCOUNT"] = "CUSTOMER_DELETE_BANK_ACCOUNT";
    HistoryActions["CUSTOMER_CHANGE_DEFAULT_BANK_ACCOUNT"] = "CUSTOMER_CHANGE_DEFAULT_BANK_ACCOUNT";
    HistoryActions["CUSTOMER_ATTACH_NOTE"] = "CUSTOMER_ATTACH_NOTE";
    HistoryActions["CUSTOMER_EDIT_NOTE"] = "CUSTOMER_EDIT_NOTE";
    HistoryActions["CUSTOMER_DELETE_NOTE"] = "CUSTOMER_DELETE_NOTE";
    // For products
    HistoryActions["PRODUCT_CREATE"] = "PRODUCT_CREATE";
    HistoryActions["PRODUCT_UPDATE"] = "PRODUCT_UPDATE";
    HistoryActions["PRODUCT_UPDATE_OPTIONS"] = "PRODUCT_UPDATE_OPTIONS";
    HistoryActions["PRODUCT_UPDATE_VARIANT"] = "PRODUCT_UPDATE_VARIANT";
    HistoryActions["PRODUCT_DELETE"] = "PRODUCT_DELETE";
    HistoryActions["PRODUCT_CHANGE_STATUS"] = "PRODUCT_CHANGE_STATUS";
    HistoryActions["PRODUCT_ARCHIVE"] = "PRODUCT_ARCHIVE";
    // For suppliers
    HistoryActions["SUPPLIER_CREATE"] = "SUPPLIER_CREATE";
    HistoryActions["SUPPLIER_UPDATE"] = "SUPPLIER_UPDATE";
    HistoryActions["SUPPLIER_DELETE"] = "SUPPLIER_DELETE";
    HistoryActions["SUPPLIER_ARCHIVE"] = "SUPPLIER_ARCHIVE";
    HistoryActions["SUPPLIER_ADD_ADDRESS"] = "SUPPLIER_ADD_ADDRESS";
    HistoryActions["SUPPLIER_UPDATE_ADDRESS"] = "SUPPLIER_UPDATE_ADDRESS";
    HistoryActions["SUPPLIER_REMOVE_ADDRESS"] = "SUPPLIER_REMOVE_ADDRESS";
    HistoryActions["SUPPLIER_CHANGE_DEFAULT_ADDRESS"] = "SUPPLIER_CHANGE_DEFAULT_ADDRESS";
    HistoryActions["SUPPLIER_ADD_BANK_ACCOUNT"] = "SUPPLIER_ADD_BANK_ACCOUNT";
    HistoryActions["SUPPLIER_UPDATE_BANK_ACCOUNT"] = "SUPPLIER_UPDATE_BANK_ACCOUNT";
    HistoryActions["SUPPLIER_DELETE_BANK_ACCOUNT"] = "SUPPLIER_DELETE_BANK_ACCOUNT";
    HistoryActions["SUPPLIER_CHANGE_DEFAULT_BANK_ACCOUNT"] = "SUPPLIER_CHANGE_DEFAULT_BANK_ACCOUNT";
    HistoryActions["SUPPLIER_CREATE_PURCHASE_ORDER"] = "SUPPLIER_CREATE_PURCHASE_ORDER";
    // For company users
    HistoryActions["USER_CREATE"] = "USER_CREATE";
    HistoryActions["USER_UPDATE"] = "USER_UPDATE";
    HistoryActions["USER_UPDATE_ROLE"] = "USER_UPDATE_ROLE";
    HistoryActions["USER_BLOCK"] = "USER_BLOCK";
    HistoryActions["USER_ACTIVATE"] = "USER_ACTIVATE";
    HistoryActions["USER_DELETE"] = "USER_DELETE";
    HistoryActions["USER_SEND_INVITE"] = "USER_SEND_INVITE";
    // For api keys
    HistoryActions["API_KEY_CREATE"] = "API_KEY_CREATE";
    HistoryActions["API_KEY_UPDATE"] = "API_KEY_UPDATE";
    HistoryActions["API_KEY_UPDATE_ROLE"] = "API_KEY_UPDATE_ROLE";
    HistoryActions["API_KEY_BLOCK"] = "API_KEY_BLOCK";
    HistoryActions["API_KEY_DELETE"] = "API_KEY_DELETE";
    // For categories
    HistoryActions["CATEGORY_CREATE"] = "CATEGORY_CREATE";
    HistoryActions["CATEGORY_UPDATE"] = "CATEGORY_UPDATE";
    HistoryActions["CATEGORY_DELETE"] = "CATEGORY_DELETE";
    // For brands
    HistoryActions["BRAND_CREATE"] = "BRAND_CREATE";
    HistoryActions["BRAND_UPDATE"] = "BRAND_UPDATE";
    HistoryActions["BRAND_DELETE"] = "BRAND_DELETE";
    // For pickup points
    HistoryActions["PICKUP_POINT_CREATE"] = "PICKUP_POINT_CREATE";
    HistoryActions["PICKUP_POINT_UPDATE"] = "PICKUP_POINT_UPDATE";
    HistoryActions["PICKUP_POINT_DELETE"] = "PICKUP_POINT_DELETE";
    HistoryActions["PICKUP_POINT_CHANGE_STATUS"] = "PICKUP_POINT_CHANGE_STATUS";
    // For invoices
    HistoryActions["INVOICE_CREATE"] = "INVOICE_CREATE";
    HistoryActions["INVOICE_UPDATE_STATUS"] = "INVOICE_UPDATE_STATUS";
    HistoryActions["INVOICE_MODIFY_ITEMS"] = "INVOICE_MODIFY_ITEMS";
    HistoryActions["INVOICE_UPDATE_DELIVERY_STATUS"] = "INVOICE_UPDATE_DELIVERY_STATUS";
    HistoryActions["INVOICE_UPDATE_CUSTOMER"] = "INVOICE_UPDATE_CUSTOMER";
    HistoryActions["INVOICE_UPDATE_PAYMENT_METHOD"] = "INVOICE_UPDATE_PAYMENT_METHOD";
    HistoryActions["INVOICE_UPDATE_DELIVERY_TYPE"] = "INVOICE_UPDATE_DELIVERY_TYPE";
    HistoryActions["INVOICE_DELETE"] = "INVOICE_DELETE";
    HistoryActions["INVOICE_PROCESS"] = "INVOICE_PROCESS";
    HistoryActions["INVOICE_CREATE_AND_PROCESS"] = "INVOICE_CREATE_AND_PROCESS";
    HistoryActions["INVOICE_ATTACH_NOTE"] = "INVOICE_ATTACH_NOTE";
    HistoryActions["INVOICE_EDIT_NOTE"] = "INVOICE_EDIT_NOTE";
    HistoryActions["INVOICE_DELETE_NOTE"] = "INVOICE_DELETE_NOTE";
    HistoryActions["INVOICE_CANCEL"] = "INVOICE_CANCEL";
    HistoryActions["INVOICE_REFUND"] = "INVOICE_REFUND";
    HistoryActions["INVOICE_SEND_RECEIPT"] = "INVOICE_SEND_RECEIPT";
    HistoryActions["INVOICE_ARCHIVE"] = "INVOICE_ARCHIVE";
    HistoryActions["INVOICE_UPDATE"] = "INVOICE_UPDATE";
    // For locations
    HistoryActions["LOCATION_CREATE"] = "LOCATION_CREATE";
    HistoryActions["LOCATION_UPDATE"] = "LOCATION_UPDATE";
    HistoryActions["LOCATION_DELETE"] = "LOCATION_DELETE";
    // For roles
    HistoryActions["ROLE_CREATE"] = "ROLE_CREATE";
    HistoryActions["ROLE_UPDATE"] = "ROLE_UPDATE";
    HistoryActions["ROLE_DELETE"] = "ROLE_DELETE";
    // For bank accounts
    HistoryActions["BANK_ACCOUNT_CREATE"] = "BANK_ACCOUNT_CREATE";
    HistoryActions["BANK_ACCOUNT_VERIFY"] = "BANK_ACCOUNT_VERIFY";
    HistoryActions["BANK_ACCOUNT_ATTACH_FILE"] = "BANK_ACCOUNT_ATTACH_FILE";
    HistoryActions["BANK_ACCOUNT_DETACH_FILE"] = "BANK_ACCOUNT_DETACH_FILE";
    HistoryActions["BANK_ACCOUNT_UPDATE"] = "BANK_ACCOUNT_UPDATE";
    HistoryActions["BANK_ACCOUNT_BLOCK"] = "BANK_ACCOUNT_BLOCK";
    HistoryActions["BANK_ACCOUNT_DELETE"] = "BANK_ACCOUNT_DELETE";
    // For external integrations
    HistoryActions["EXTERNAL_INTEGRATION_CREATE"] = "EXTERNAL_INTEGRATION_CREATE";
    HistoryActions["EXTERNAL_INTEGRATION_SYNC"] = "EXTERNAL_INTEGRATION_SYNC";
    HistoryActions["EXTERNAL_INTEGRATION_ACTIVATE"] = "EXTERNAL_INTEGRATION_ACTIVATE";
    HistoryActions["EXTERNAL_INTEGRATION_DEACTIVATE"] = "EXTERNAL_INTEGRATION_DEACTIVATE";
    HistoryActions["EXTERNAL_INTEGRATION_WIPE"] = "EXTERNAL_INTEGRATION_WIPE";
    HistoryActions["EXTERNAL_INTEGRATION_DELETE"] = "EXTERNAL_INTEGRATION_DELETE";
    HistoryActions["EXTERNAL_INTEGRATION_CURRENCY_UPDATE"] = "EXTERNAL_INTEGRATION_CURRENCY_UPDATE";
    // For external apps
    HistoryActions["EXTERNAL_APP_CREATE"] = "EXTERNAL_APP_CREATE";
    HistoryActions["EXTERNAL_APP_UPDATE"] = "EXTERNAL_APP_UPDATE";
    HistoryActions["EXTERNAL_APP_ACTIVATE"] = "EXTERNAL_APP_ACTIVATE";
    HistoryActions["EXTERNAL_APP_DEACTIVATE"] = "EXTERNAL_APP_DEACTIVATE";
    HistoryActions["EXTERNAL_APP_DELETE"] = "EXTERNAL_APP_DELETE";
    HistoryActions["EXTERNAL_APP_CURRENCY_UPDATE"] = "EXTERNAL_APP_CURRENCY_UPDATE";
    HistoryActions["EXTERNAL_APP_SYNC"] = "EXTERNAL_APP_SYNC";
    // For delivery services
    HistoryActions["DELIVERY_SERVICE_CREATE"] = "DELIVERY_SERVICE_CREATE";
    HistoryActions["DELIVERY_SERVICE_UPDATE"] = "DELIVERY_SERVICE_UPDATE";
    HistoryActions["DELIVERY_SERVICE_DELETE"] = "DELIVERY_SERVICE_DELETE";
    HistoryActions["DELIVERY_SERVICE_ACTIVATE"] = "DELIVERY_SERVICE_ACTIVATE";
    HistoryActions["DELIVERY_SERVICE_DEACTIVATE"] = "DELIVERY_SERVICE_DEACTIVATE";
    // For officers
    HistoryActions["OFFICER_CREATE"] = "OFFICER_CREATE";
    HistoryActions["OFFICER_UPDATE"] = "OFFICER_UPDATE";
    HistoryActions["OFFICER_VERIFY"] = "OFFICER_VERIFY";
    HistoryActions["OFFICER_DELETE"] = "OFFICER_DELETE";
    // commercial invoices
    HistoryActions["COMMERCIAL_INVOICE_STATUS"] = "COMMERCIAL_INVOICE_UPDATE_STATUS";
    HistoryActions["COMMERCIAL_INVOICE_CREATE"] = "COMMERCIAL_INVOICE_CREATE";
    HistoryActions["COMMERCIAL_INVOICE_UPDATE"] = "COMMERCIAL_INVOICE_UPDATE";
    HistoryActions["COMMERCIAL_INVOICE_DELETE"] = "COMMERCIAL_INVOICE_DELETE";
    HistoryActions["COMMERCIAL_INVOICE_ATTACH_NOTE"] = "COMMERCIAL_INVOICE_ATTACH_NOTE";
    HistoryActions["COMMERCIAL_INVOICE_EDIT_NOTE"] = "COMMERCIAL_INVOICE_EDIT_NOTE";
    HistoryActions["COMMERCIAL_INVOICE_DELETE_NOTE"] = "COMMERCIAL_INVOICE_DELETE_NOTE";
    // Random ones for everything
    HistoryActions["CREATE"] = "CREATE";
    HistoryActions["UPDATE"] = "UPDATE";
    HistoryActions["DELETE"] = "DELETE";
})(HistoryActions = exports.HistoryActions || (exports.HistoryActions = {}));
